import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../utils/AuthContext';
import '../styles/styles.css';

const CancelPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { authState } = useAuth();
    const urlParams = new URLSearchParams(location.search);
    const sessionId = urlParams.get('session_id');

    // Log auth state for debugging
    React.useEffect(() => {
        console.log('[CancelPage] authState:', authState);
        // Clean up URL params after processing
        window.history.replaceState({}, document.title, location.pathname);
    }, [location, authState]);

    const handleBackToPayment = () => {
        console.log('[CancelPage] Navigating to /upgrade, authState:', authState);
        navigate('/upgrade');
    };

    return (
        <div className="main-content cancel-page">
            <h2>Payment Cancelled</h2>
            <p>Your payment was cancelled. No charges have been applied.</p>
            {sessionId && <p>Session ID: {sessionId} (for support reference)</p>}
            <div className="button-group">
                <button className="back-button" onClick={handleBackToPayment}>
                    Back to Payment
                </button>
            </div>
        </div>
    );
};

export default CancelPage;